// Visual state of a campaign / recipient.

export const CAMPAIGN_STATUS_COLOR = {
	draft: "default",
	running: "primary",
	paused: "default",
	completed: "default",
	canceled: "default",
};

export const percentDone = counts => {
	if (!counts || !counts.total) return 0;
	const finished = counts.total - counts.pending - counts.sending;
	return Math.round((finished / counts.total) * 100);
};

export const isActive = status => status === "running" || status === "paused";
